export const GET_GROUPS_LIST_REQUEST = 'GET_GROUPS_LIST_REQUEST';
export const GET_GROUPS_LIST_SUCCESS = 'GET_GROUPS_LIST_SUCCESS';
export const GET_GROUPS_LIST_FAILURE = 'GET_GROUPS_LIST_FAILURE';
export const SET_GROUPS_FILTERED = 'SET_GROUPS_FILTERED';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/constants/get_groups_list.constants.js